var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppInsightsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 113,
    viewBox: "0 0 100 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.7353C0 84.2287 4.47715 79.7647 10 79.7647C15.5228 79.7647 20 84.2287 20 89.7353V103.029C20 108.536 15.5228 113 10 113C4.47715 113 0 108.536 0 103.029V89.7353Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56.5C40 50.9934 44.4772 46.5294 50 46.5294C55.5228 46.5294 60 50.9934 60 56.5V103.029C60 108.536 55.5228 113 50 113C44.4772 113 40 108.536 40 103.029V56.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 9.97059C80 4.46399 84.4772 0 90 0C95.5228 0 100 4.46398 100 9.97059V103.029C100 108.536 95.5228 113 90 113C84.4772 113 80 108.536 80 103.029V9.97059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppInsightsLogo);
export default __webpack_public_path__ + "static/media/app-insights-logo.c812d2d2c9fa46ea98d754bc0fefc3d7.svg";
export { ForwardRef as ReactComponent };